export default __webpack_public_path__ + "static/media/ico_matricula.b9238a38.svg";